import axios from '@axios'

const route = 'report/customer/list_customer'

export default {
  namespaced: true,
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {

    index(context, {
      date_start, date_end, itemsPerPage, page, search,
    }) {
      return axios.get(`${route}?date_start=${date_start
      }&date_end=${date_end
      }&page=${page
      }&items_per_page=${itemsPerPage}`)
    },

    getExportExcel(constext, data) {
      return axios.post(`${route}/export_excel`, data, { responseType: 'blob' })
    },

    getExportPdf(constext, data) {
      return axios.post(`${route}/export_pdf`, data, { responseType: 'blob' })
    },

  },
}
